import { connect } from "react-redux";
import RmTickets from "./rmList";
import { bindActionCreators } from "redux";
import {fetchRmTicket, getRmTicketsFilterDropDown} from "services/redux/maintenance/rmTicket/action";
const mapStateToProps = (state) => ({
    rmTicket: state.rmTicketReducer.rmTicket,
    rmTicketFilter: state.rmTicketReducer.rmTicketFilter
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        fetchRmTicket,
        getRmTicketsFilterDropDown
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(RmTickets);
